import { ShadowGenerator } from '@babylonjs/core/Lights/Shadows/shadowGenerator';
import type { ShadowQuality } from '../ui/settings';

const RANK: Record<ShadowQuality, number> = { off: 0, low: 1, medium: 2, high: 3 };

/** The lower of the setting and a cap: the headset never filters above `low`, whatever is set. */
export function capShadowQuality(setting: ShadowQuality, cap: ShadowQuality): ShadowQuality {
  return RANK[setting] <= RANK[cap] ? setting : cap;
}

/**
 * Map size and filtering for a quality. `off` turns the light's shadows off, which both stops the
 * shadow map from being rendered and drops the shadow sampling from every material it lights.
 */
export function applyShadowQuality(shadows: ShadowGenerator, quality: ShadowQuality): void {
  shadows.getLight().shadowEnabled = quality !== 'off';
  shadows.filteringQuality =
    quality === 'high'
      ? ShadowGenerator.QUALITY_HIGH
      : quality === 'medium'
        ? ShadowGenerator.QUALITY_MEDIUM
        : ShadowGenerator.QUALITY_LOW;
  // A finer map only pays off with the finest filtering, and the headset never gets there.
  const size = quality === 'high' ? 2048 : 1024;
  if (shadows.mapSize !== size) shadows.mapSize = size;
}
